module.exports = __webpack_public_path__ + "img/lr.1c4be1e3.jpg";